module.exports = __webpack_public_path__ + "bg_login.b94de62a35a89bd295c8.svg";